import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Alert, Button, MaterialIcons } from '@iclinic/design-system';
import {
  getLoginWithGoogleReady,
  getLoginWithGoogle,
} from 'features/new-auth/state/selectors';
import { loginWithGoogleAuth2Request } from '../state/actions';
import GoogleIcon from './GoogleIcon';
import useStyles from './SocialLogin.styles';

const { ErrorOutlineOutlined } = MaterialIcons;

export default function LoginWith(): JSX.Element {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loginWithGoogleReady, loginWithGoogle] = [
    useSelector(getLoginWithGoogleReady),
    useSelector(getLoginWithGoogle),
  ];

  return (
    <>
      <Box>
        {loginWithGoogle.error && (
          <Box my={2}>
            <Alert
              severity="error"
              elevation={0}
              icon={<ErrorOutlineOutlined />}
              message={loginWithGoogle.errorMessage}
            />
          </Box>
        )}
        <Button
          className={classes.socialButton}
          fullWidth
          variant="outlined"
          startIcon={<GoogleIcon />}
          disabled={!loginWithGoogleReady}
          onClick={() => dispatch(loginWithGoogleAuth2Request())}
        >
          Entrar com Google
        </Button>
      </Box>
    </>
  );
}
